import { env } from 'utils/envManager/envManager'

import { SERVER_PATH } from '../../../../constants/CIAM'

export const initialize = () => {
	window.myTSAccountProtection = new window.TSAccountProtection(
		env.NEXT_PUBLIC_CIAM_CLIENT_ID,
		{
			serverPath: `${env.NEXT_PUBLIC_API_DOMAIN}${SERVER_PATH}`,
			enableSessionToken: true,
		}
	)
	window.myTSAccountProtection.init()
}
